function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as comlink from 'comlink';
import DialogHandler from '../handler/DialogHandler';
import { addVisibilityChangeListener, removeVisibilityChangeListener } from '../calls/visibilityChangeListener';
import { addApiListener, dispatchApiEvent, removeApiListener } from '../helper/apiListenerHelper';
import getUserInfo from '../calls/getUserInfo';
import { sendMessageToGroup, sendMessageToPage, sendMessageToUser } from '../calls/sendMessage';
import { setTappHeight } from '../util/heightHelper';
export class FrameWrapper {
  constructor() {
    _defineProperty(this, "resolve", null);
    _defineProperty(this, "exposedFunctions", null);
    _defineProperty(this, "resizeListener", null);
    _defineProperty(this, "ready", new Promise(res => {
      this.resolve = res;
    }));
    _defineProperty(this, "values", null);
    _defineProperty(this, "functions", {
      addGeoLocationListener: async (value, callback) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.addGeoLocationListener(value, callback && comlink.proxy(result => callback(result)));
      },
      addScrollListener: async (value, callback) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.addScrollListener(value, callback && comlink.proxy(result => callback(result)));
      },
      addVisibilityChangeListener: async callback => addVisibilityChangeListener(callback),
      addWindowMetricsListener: async callback => {
        if (!this.initialized) await this.ready;
        const {
          id,
          shouldInitialize
        } = addApiListener('windowMetricsListener', callback);
        if (shouldInitialize) {
          void this.exposedFunctions.addWindowMetricsListener(comlink.proxy(result => {
            dispatchApiEvent('windowMetricsListener', result);
          }));
          window.addEventListener('resize', this.resizeListener = () => {
            void (async () => {
              const metrics = await this.exposedFunctions.getWindowMetrics();
              dispatchApiEvent('windowMetricsListener', metrics);
            })();
          });
        }
        return id;
      },
      customCallbackFunction: async (type, data) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.customCallbackFunction(type, data);
      },
      getAvailableSharingServices: async () => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.getAvailableSharingServices();
      },
      getAccessToken: async accessToken => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.getAccessToken(accessToken);
      },
      getGeoLocation: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.getGeoLocation(value);
      },
      getUserInfo: async query => {
        if (!this.initialized) await this.ready;
        return getUserInfo(this, query);
      },
      getScrollPosition: async () => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.getScrollPosition();
      },
      getWindowMetrics: async () => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.getWindowMetrics();
      },
      invokeCall: async (value, callback) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.invokeCall(value, callback && comlink.proxy(result => callback(result)));
      },
      invokeDialogCall: async (value, callback) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.invokeDialogCall(value, callback && comlink.proxy(result => callback(result)));
      },
      login: async (value, callback, closeCallback) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.login(value, callback && comlink.proxy(result => callback(result)), closeCallback && comlink.proxy(() => closeCallback()));
      },
      logout: async () => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.logout();
      },
      navigateBack: async () => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.navigateBack();
      },
      openImage: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.openImage(value);
      },
      openMedia: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.openMedia(value);
      },
      openUrl: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.openUrl(value);
      },
      openVideo: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.openVideo(value);
      },
      refreshAccessToken: async () => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.refreshAccessToken();
      },
      refreshData: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.refreshData(value);
      },
      removeGeoLocationListener: async id => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.removeGeoLocationListener(id);
      },
      removeScrollListener: async id => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.removeScrollListener(id);
      },
      removeVisibilityChangeListener(number) {
        removeVisibilityChangeListener(number);
        return Promise.resolve();
      },
      removeWindowMetricsListener: async id => {
        if (!this.initialized) await this.ready;
        const shouldRemove = removeApiListener('windowMetricsListener', id);
        if (shouldRemove) {
          void this.exposedFunctions.removeWindowMetricsListener(id);
          if (this.resizeListener) window.removeEventListener('resize', this.resizeListener);
          this.resizeListener = null;
        }
      },
      selectPage: async options => {
        if (!this.initialized) await this.ready;
        await this.exposedFunctions.selectPage(options);
      },
      scrollToY: async (position, duration) => {
        if (!this.initialized) await this.ready;
        await this.exposedFunctions.scrollToY(position, duration);
      },
      sendMessageToGroup: async (groupId, message) => {
        if (!this.initialized) await this.ready;
        return sendMessageToGroup(this, message, groupId);
      },
      sendMessageToPage: async message => {
        if (!this.initialized) await this.ready;
        return sendMessageToPage(this, message);
      },
      sendMessageToUser: async (userId, message) => {
        if (!this.initialized) await this.ready;
        return sendMessageToUser(this, message, userId);
      },
      setAdminMode: async enabled => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.setAdminMode(enabled);
      },
      setDisplayTimeout: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.setDisplayTimeout(value);
      },
      setFloatingButton: async (value, callback) => {
        var _value$items;
        if (!this.initialized) await this.ready;
        value.items = (_value$items = value.items) !== null && _value$items !== void 0 ? _value$items : [];
        const itemClickFunctions = value.items.map(x => x.onClick);
        value.items = value.items.map(x => ({
          ...x,
          onClick: undefined
        }));
        const cb = callback && comlink.proxy(data => {
          if (data !== null && data !== void 0 && data.item && itemClickFunctions[data.index]) {
            itemClickFunctions[data.index]();
          } else {
            callback();
          }
        });
        // @ts-ignore
        return this.exposedFunctions.setFloatingButton(value, cb);
      },
      setHeight: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.setHeight(value);
      },
      setOverlay: async (value, callback) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.setOverlay(value, callback && comlink.proxy(() => callback()));
      },
      setRefreshScrollEnabled: async enabled => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.setRefreshScrollEnabled(enabled);
      },
      setScanQrCode: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.setScanQrCode(value !== null && value !== void 0 ? value : {
          cancel: false
        });
      },
      setTempDesignSettings: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.setTempDesignSettings(value);
      },
      setWaitCursor: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.setWaitCursor(value);
      },
      storageGetItem: async (key, accessMode) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.storageGetItem(key, accessMode);
      },
      storageRemoveItem: async (key, accessMode) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.storageRemoveItem(key, accessMode);
      },
      storageSetItem: async (key, value, accessMode, tappIds) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.storageSetItem(key, value, accessMode, tappIds);
      },
      vibrate: async value => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.vibrate(value);
      },
      scrollByY: async (value, duration) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.scrollByY(value, duration);
      },
      createDialog: config => {
        return new DialogHandler(config, this.functions.openDialog, this.exposedFunctions.closeDialog, this.functions.dispatchEventToDialogClient, this.functions.addDialogClientEventListener);
      },
      closeDialog: async dialogId => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.closeDialog(dialogId);
      },
      openDialog: async (config, callback) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.openDialog(config, comlink.proxy(callback));
      },
      setDialogResult: async (buttonType, result) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.setDialogResult(buttonType, result);
      },
      dispatchEventToDialogClient: async (dialogId, data) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.dispatchEventToDialogClient(dialogId, data);
      },
      addDialogClientEventListener: async (dialogId, callback) => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.addDialogClientEventListener(dialogId, comlink.proxy(callback));
      },
      dispatchEventToDialogHost: async data => {
        if (!this.initialized) await this.ready;
        return this.exposedFunctions.dispatchEventToDialogHost(data);
      },
      addDialogHostEventListener: async callback => {
        if (!this.initialized) await this.ready;
        const listenerKey = `dialogHostEventListener`;
        const {
          id,
          shouldInitialize
        } = addApiListener(listenerKey, callback);
        if (shouldInitialize) {
          this.exposedFunctions.addDialogHostEventListener(comlink.proxy(data => {
            dispatchApiEvent(listenerKey, data);
          }));
        }
        return id;
      },
      removeDialogHostEventListener: async id => {
        if (!this.initialized) await this.ready;
        const listenerKey = `dialogHostEventListener`;
        const shouldRemove = removeApiListener(listenerKey, id);
        if (shouldRemove) {
          // this.exposedFunctions.removeDialogHostEventListener(0);
        }
      },
      removeDialogClientEventListener: async () => {}
    });
    _defineProperty(this, "initialized", false);
    const initialDataTag = document.querySelector('#__CHAYNS_DATA__');
    if (initialDataTag) {
      this.values = JSON.parse(initialDataTag.innerHTML);
    }
  }
  async init() {
    if (this.initialized) return;
    const exposed = comlink.wrap(comlink.windowEndpoint(window.parent))[window.name];
    const dataListener = () => exposed.addDataListener(comlink.proxy(_ref => {
      let {
        type,
        value
      } = _ref;
      if (this.initialized) {
        this.values[type] = value;
      }
      this.values[type] = value;
      document.dispatchEvent(new CustomEvent('chayns_api_data', {
        detail: {
          type,
          value
        }
      }));
    }));
    let hostReadyCallback = null;
    await Promise.race([dataListener(), new Promise(resolve => {
      window.addEventListener('message', hostReadyCallback = ev => {
        if (ev.data === 'chayns-api-host-ready') {
          void dataListener().then(resolve);
        }
      });
    })]);
    if (hostReadyCallback) window.removeEventListener('message', hostReadyCallback);
    this.values = await exposed.getInitialData();
    this.exposedFunctions = exposed.functions;
    this.initialized = true;
    this.resolve(null);
    setTappHeight(this.functions.setHeight);
  }
  addDataListener(cb) {
    const listener = ev => ev.detail && cb(ev.detail);
    document.addEventListener('chayns_api_data', listener);
    return () => {
      document.removeEventListener('chayns_api_data', listener);
    };
  }
  getSSRData() {
    return null;
  }
  getInitialData() {
    return this.values;
  }
}